export default function ImportDocumentDirectiveController(
  $q,
  importDocumentDialog,
  ssDialogService
) {
  const vm = this;

  vm.file = null;
  vm.handleImportDialogClick = _handleImportDialogClick;

  function _handleImportDialogClick($event) {
    ssDialogService.dialogs.global.importDocumentDialog = ssDialogService.alert(
      importDocumentDialog.getOptions($event, {
        customerId: vm.customerId,
        importTypeId: vm.importTypeId,
        title: vm.title,
        entityId: vm.entityId,
        mimeType: vm.mimeType,
        fileName: vm.fileName,
        refreshCallBack: _refreshCallBack,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.global.importDocumentDialog);
  }

  function _refreshCallBack(importResults) {
    vm.refreshCallBack()(importResults);
  }
}

ImportDocumentDirectiveController.$inject = [
  '$q',
  'importDocumentDialog',
  'ssDialogService'
];
